
import {signInWithEmailAndPassword} from "firebase/auth";
import React,  { useState } from 'react'
import { auth } from '../Firebase/firebaseConfig/firebase';
import { Link } from "react-router-dom"
import '../../style/Login.css'
import AuthDetails from "./AuthDetails";
import { useAuth } from '../AuthContext';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import '../../style/Carrito.css';

const MySwal = withReactContent(Swal);

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
	const { setAuthUserId } = useAuth();

  const bienvenido = (id) => {
    Swal.fire({
      title: "¡Bienvenido!",
      text: "¡Que disfrutes tu compra!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ingresar",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire("Bienvenido", "Gracias por visitarnos.", "Listo");
      }
    });
  };

  const logIn = (e) =>{
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
    .then((userCredential)=>{
      bienvenido(userCredential.user.email);
      console.log(userCredential);
			setAuthUserId(userCredential.user.email);
      setLoggedIn(true);

    }).catch((error)=>{
			Swal.fire({
				icon: "error",
				text: "Usuario o contraseña incorrecta.",
			});
      console.log(error);
    })
  }
  return (    
    <div className='container mx-auto bg-light mt-2 mb-4' style={{ maxWidth: '400px' }} id='login-form'>
      {loggedIn ? (
        <AuthDetails/>
      ) : (  
      <form onSubmit={logIn} >
        <h2 className="card-title text-center mt-3">Bienvenido/a</h2>
        <input type="email" className='form-control mt-5 col-sm-6' placeholder='Usuario (E-mail)' 
        value={email} onChange={(e)=> setEmail(e.target.value)}/>
        <input type="password" className='form-control mt-3 col-sm-6' placeholder='Contraseña' 
        value={password} onChange={(e)=> setPassword(e.target.value)}/>
        <button className="btn btn-info text-light mt-3" style={{ width: '100%' }} type='submit'>Ingresar</button>
        <p className="login-text" >¿Usuario nuevo? <Link to = "/Signup"> Registrarse </Link></p>
      </form>
      
      )}
    </div>
    
  )
}
export default Login;